import React, { useMemo } from 'react';
import { FormProps } from 'react-final-form';
import { FORM_ERROR } from 'final-form';

import {
  FeedCityFilter,
  FeedCityFilterProps,
  FormValues,
} from '@components/catalog/FeedCityFilter';
import { UNKNOWN_ERROR_MESSAGE } from '@constants';
import { getFieldsSingleError } from '@utils/common';

import {
  useFeedCityFilterQuery,
  useFeedCityFilterUpdateCityMutation,
} from './graphql.v3.generated';

type Props = Pick<FeedCityFilterProps, 'className' | 'value' | 'onChange'>;

export const FeedCityFilterContainer: React.FC<Props> = (props) => {
  const { data } = useFeedCityFilterQuery({
    context: {
      batch: true,
      ignoreAuthError: true,
    },
  });
  const options = useMemo(
    () => (
      data?.viewer?.city
        ? [{ value: data.viewer.city.id, label: data.viewer.city.name }]
        : []
    ),
    [data],
  );
  const initialValues = useMemo(
    () => (
      options.length
        ? { city: options[0] }
        : {}
    ),
    [options],
  );
  const [updateCity] = useFeedCityFilterUpdateCityMutation();

  if (!data) {
    return null;
  }

  const onSubmit: FormProps<FormValues>['onSubmit'] = async (values) => {
    const response = await updateCity({
      variables: {
        city: values.city.value,
      },
    });

    if (response.errors || !response.data?.editProfileSettings) {
      return {
        [FORM_ERROR]: UNKNOWN_ERROR_MESSAGE(),
      };
    }

    const rawErrors = response.data.editProfileSettings.errors;
    if (rawErrors?.length) {
      const fieldsErrors = getFieldsSingleError(rawErrors);
      return {
        ...fieldsErrors,
        [FORM_ERROR]: fieldsErrors.__all__,
      };
    }

    return undefined;
  };

  return (
    <FeedCityFilter
      {...props}
      options={options}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
};
